import { useState } from "react";
import { CalendarDays, XCircle } from "lucide-react";
import { useAuth } from "../auth/AuthProvider";
import { Button } from "../../shared/ui/Button";
import { Card, EmptyState } from "../../shared/ui/Card";
import { PageSkeleton, StatusBadge } from "../../shared/ui/Status";
import { useScheduling, useSchedulingActions } from "./useScheduling";
export function MemberSchedulePanel() {
  const { session } = useAuth();
  const scheduling = useScheduling();
  const actions = useSchedulingActions();
  const [notice, setNotice] = useState("");
  const [error, setError] = useState("");
  if (!session || !scheduling.data) return <PageSkeleton />;
  const own = scheduling.data.schedules.filter(
    (s) => s.memberId === session.profile.id,
  );
  const venueNames = Object.fromEntries(
    scheduling.data.venues.map((v) => [v.id, v.name]),
  );
  const cancel = async (id: string) => {
    if (!window.confirm("确认取消该预约？距开课不足3小时将被记录为晚取消。"))
      return;
    setNotice("");
    setError("");
    try {
      const result = await actions.cancelSchedule(id);
      setNotice(
        result.status === "cancelled"
          ? "已提前3小时取消，不扣课。"
          : "距开课不足3小时，已记录晚取消；V4首期不自动扣课。",
      );
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "取消失败");
    }
  };
  return (
    <section className="page-stack member-schedules">
      <div className="section-divider">
        <span>我的预约</span>
        <h2>排课记录</h2>
      </div>
      {(notice || error) && (
        <div
          className={
            error ? "inline-notice inline-notice--error" : "inline-notice"
          }
        >
          {error || notice}
        </div>
      )}
      {own.length ? (
        <Card className="directory-card">
          <div className="schedule-list">
            {own
              .slice()
              .reverse()
              .map((s) => (
                <article key={s.id}>
                  <CalendarDays />
                  <div>
                    <span>{new Date(s.startAt).toLocaleString("zh-CN")}</span>
                    <h3>{venueNames[s.venueId]}</h3>
                    <p>
                      {Math.round(
                        (new Date(s.endAt).getTime() -
                          new Date(s.startAt).getTime()) /
                          60000,
                      )}
                      分钟
                    </p>
                  </div>
                  <StatusBadge>{s.status}</StatusBadge>
                  {s.status === "scheduled" && (
                    <Button
                      variant="ghost"
                      onClick={() => cancel(s.id)}
                      disabled={actions.pending}
                    >
                      <XCircle size={15} />
                      取消预约
                    </Button>
                  )}
                </article>
              ))}
          </div>
        </Card>
      ) : (
        <EmptyState title="暂无预约" description="员工排课后会在这里显示。" />
      )}
    </section>
  );
}
